import { Select } from "antd"
import { FC } from "react"
import { PAGE_NAMES, PAGES } from "../../../types/pages"

interface ISelectAccessPage {
  accesesPage: [string]
  setAccesesPage: (accesesPages: [string]) => void
}

const SelectAccessPage: FC<ISelectAccessPage> = ({ setAccesesPage, accesesPage }) => {
  const selectOptions = [
    {
      label: PAGE_NAMES.OPPORTUNITIES_REPORT,
      value: PAGE_NAMES.OPPORTUNITIES_REPORT,
    },
  ]

  function onChange(value: [string]) {
    setAccesesPage(value)
  }

  return (
    <Select
      mode="tags"
      placeholder="Accesses Page"
      optionFilterProp="label"
      showSearch
      options={selectOptions}
      defaultValue={accesesPage}
      onChange={onChange}
    />
  )
}

export default SelectAccessPage
